import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import Select from 'react-select'
import Datetime from 'react-datetime'

import useViewModel from './ViewModel'
import { findReactSelectOption } from 'Utils/findReactSelectOption'
import moment from 'moment'
import { DELIVERY_TIME_OPTIONS } from 'Configuration/Paco'
import { ClientSideTable } from 'Presentation/Components/Table'

// const STATUS_OPTIONS = SHIPPING_STATUS_OPTIONS.map(item => ({
//   label: item.title,
//   value: item.key,
// }))

const ShippingFormView: React.FC = () => {
  const {
    isCreate,
    formik,
    isView,
    shippingRequestId,
    handleClose,
    onSubmitShippingItem,
    PILE_ITEMS_CONFIGS,
    hasItemInvalid,
    staticShippingRequest,
  } = useViewModel()

  const deliveryTimeOptions = DELIVERY_TIME_OPTIONS.map(item => ({
    label: item,
    value: item,
  }))

  return (
    <ViewPageTitle isCreate={isCreate} isView={isView} shippingRequestId={shippingRequestId}>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <div className='card'>
        <div className='card-body py-lg-10 px-lg-10 min-h-500px'>
          <div className='row gy-3'>
            {/* begin:: Sale Order */}
            <div className='col-12'>
              <label htmlFor='name' className='fs-6 mb-3'>
                Sale Order
                <span className='required' />
              </label>

              <input
                disabled
                value={staticShippingRequest.saleOrderCode ?? ''}
                className='form-control form-control-sm'
              />
            </div>
            {/* end:: Sale Order */}

            {/* begin:: Division */}
            <div className='col-12 col-xl-4'>
              <label htmlFor='name' className='fs-6 mb-3'>
                หน่วยงาน
                <span className='required' />
              </label>

              <input
                disabled
                value={staticShippingRequest?.division ?? ''}
                className='form-control form-control-sm'
              />
            </div>
            {/* end:: Division */}

            {/* begin:: Customer Title */}
            <div className='col-12 col-xl-4'>
              <label htmlFor='name' className='fs-6 mb-3'>
                ชื่อลูกค้า
                <span className='required' />
              </label>

              <input
                disabled
                value={staticShippingRequest?.customerTitle ?? ''}
                className='form-control form-control-sm'
              />
            </div>

            {/* begin:: Date */}
            <div className='col-12 col-xl-4 mb-5'>
              <label htmlFor='name' className='fs-6 mb-3'>
                วันที่ขนส่ง
                <span className='required' />
              </label>

              <Datetime
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    disabled
                    name='date'
                    className='form-control form-control-sm'
                  />
                )}
                value={undefined}
              />
            </div>
            {/* end:: Date */}

            <div className='col-12'>
              <div className='fs-4 fw-bold d-flex justify-content-between flex-row align-items-center'>
                <div>
                  รายการเสาเข็ม <span className='required' />
                </div>
              </div>

              <hr />
              <form
                onSubmit={(e: any) => {
                  e.preventDefault()
                }}>
                <ClientSideTable
                  isGrey
                  data={formik.values.shippingItems}
                  columns={PILE_ITEMS_CONFIGS}
                  items_per_page={10}
                />
                {!isView &&
                  (staticShippingRequest.jobStatus === '' ||
                    staticShippingRequest.jobStatus === 'pending') &&
                  !isCreate && (
                    <div
                      className='col-12 d-flex flex-row justify-content-end'
                      style={{ columnGap: '12px' }}>
                      <button
                        type='reset'
                        className='btn btn-sm btn-light fw-bolder'
                        onClick={handleClose}
                        disabled={formik.isSubmitting}>
                        ยกเลิก
                      </button>
                      <button
                        type='submit'
                        className='btn btn-sm btn-success me-4 fw-bold'
                        disabled={formik.isSubmitting}
                        onClick={onSubmitShippingItem}>
                        บันทึก
                      </button>
                    </div>
                  )}
              </form>
            </div>

            <hr />
          </div>
          <form
            onSubmit={(e: any) => {
              formik.handleSubmit(e)
              e.preventDefault()
            }}>
            <div className='row gy-3'>
              {/* begin:: Start Shipping Time */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  เวลาเริ่มขนส่ง
                  <span className='required' />
                </label>

                <Datetime
                  timeFormat={'HH:mm:ss a'}
                  dateFormat='DD/MM/YYYY'
                  renderInput={props => (
                    <input
                      {...props}
                      autoComplete='off'
                      name='startShippingAt'
                      className='form-control form-control-sm'
                      onBlur={formik.getFieldProps('startShippingAt').onBlur}
                    />
                  )}
                  onChange={selectedDate => {
                    if (selectedDate)
                      formik.setFieldValue('startShippingAt', moment(selectedDate).toDate())
                  }}
                  // @ts-ignore
                  value={
                    formik.values.startShippingAt
                      ? moment(formik.values.startShippingAt).toDate()
                      : undefined
                  }
                />

                {formik.touched.startShippingAt && formik.errors.startShippingAt && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.startShippingAt as any}</div>
                  </div>
                )}
              </div>
              {/* end:: Start Shipping Time */}

              {/* begin:: End Shipping Time */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  เวลาที่สิ้นสุดการขนส่ง
                  <span className='required' />
                </label>

                <Datetime
                  timeFormat={'HH:mm:ss a'}
                  dateFormat='DD/MM/YYYY'
                  renderInput={props => (
                    <input
                      {...props}
                      autoComplete='off'
                      name='endShippingAt'
                      className='form-control form-control-sm'
                      onBlur={formik.getFieldProps('endShippingAt').onBlur}
                    />
                  )}
                  onChange={selectedDate => {
                    if (selectedDate)
                      formik.setFieldValue('endShippingAt', moment(selectedDate).toDate())
                  }}
                  value={
                    formik.values.endShippingAt
                      ? moment(formik.values.endShippingAt).toDate()
                      : undefined
                  }
                />

                {formik.touched.endShippingAt && formik.errors.endShippingAt && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.endShippingAt as any}</div>
                  </div>
                )}
              </div>
              {/* end:: End Shipping Time */}

              <div className='col-12 col-xl-4 mb-5'>
                <label className='fs-6 mb-3'>
                  เลขที่ใบโอนย้าย <span className='required' />
                </label>

                <input
                  {...formik.getFieldProps('transferDocumentNo')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.transferDocumentNo || formik.errors.transferDocumentNo) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.transferDocumentNo}</div>
                  </div>
                )}
              </div>

              <div className='col-12 col-xl-4 mb-5'>
                <label className='fs-6 mb-3'>จำนวนเสา/เที่ยว</label>

                <input
                  {...formik.getFieldProps('pilePerRound')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.pilePerRound || formik.errors.pilePerRound) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.pilePerRound}</div>
                  </div>
                )}
              </div>

              <div className='col-4 mb-5'>
                <label className='fs-6 mb-3'>เวลาส่ง</label>

                <Select
                  name='deliveryTime'
                  isSearchable={true}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={deliveryTimeOptions}
                  onBlur={formik.getFieldProps('deliveryTime').onBlur}
                  onChange={(selectedOption: any) => {
                    if (selectedOption) formik.setFieldValue('deliveryTime', selectedOption.value)
                  }}
                  value={findReactSelectOption({
                    value: formik.getFieldProps('deliveryTime').value,
                    options: deliveryTimeOptions,
                  })}
                  placeholder='เลือกเวลาส่ง'
                />

                {(formik.touched.deliveryTime || formik.errors.deliveryTime) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.deliveryTime}</div>
                  </div>
                )}
              </div>

              <div className='col-4 mb-5'>
                <label className='fs-6 mb-3'>การขนส่ง</label>

                <input
                  {...formik.getFieldProps('deliveryBy')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.deliveryBy || formik.errors.deliveryBy) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.deliveryBy}</div>
                  </div>
                )}
              </div>

              <div className='col-4 mb-5'>
                <label className='fs-6 mb-3'>ทะเบียนรถ</label>

                <input
                  {...formik.getFieldProps('vehicleNo')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.vehicleNo || formik.errors.vehicleNo) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.deliveryBy}</div>
                  </div>
                )}
              </div>

              <div className='col-4 mb-5'>
                <label className='fs-6 mb-3'>ชื่อผู้นำส่ง</label>

                <input
                  {...formik.getFieldProps('driverFullName')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.driverFullName || formik.errors.driverFullName) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.driverFullName}</div>
                  </div>
                )}
              </div>

              <div className='card-footer'>
                {!isView &&
                  (staticShippingRequest.jobStatus === '' ||
                    staticShippingRequest.jobStatus === 'pending') && (
                    <div
                      className='col-12 d-flex flex-row justify-content-end'
                      style={{ columnGap: '12px' }}>
                      <button
                        type='reset'
                        className='btn btn-sm btn-light fw-bolder'
                        onClick={handleClose}
                        disabled={formik.isSubmitting}>
                        ยกเลิก
                      </button>
                      <button
                        type='submit'
                        className='btn btn-sm btn-success me-4 fw-bold'
                        disabled={formik.isSubmitting || !formik.isValid || hasItemInvalid}>
                        บันทึก
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { isCreate: boolean; isView: boolean; shippingRequestId: any }> = ({
  children,
  isCreate,
  isView,
  shippingRequestId,
}) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/shipping',
            title: 'Shipping request',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: false,
            isSeparator: false,
            path: `/shipping-request/${shippingRequestId}`,
            title: 'Detail',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'Form',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
        ]}>
        {isView ? 'Shipping Detail' : isCreate ? 'Add Shipping' : 'Edit Shipping'}
      </PageTitle>

      {children}
    </>
  )
}

export default ShippingFormView
